export default "__VITE_ASSET__5901b561__"